import {
  shouldShowDaytimeAvailability,
  shouldShowDaytimeServiceScheduler,
  shouldShowFulltimeAvailability,
} from '@rover/react-lib/src/pages/search/SearchPage/utilities';
import type { SearchFilters, SearchFiltersOptions, ServiceType } from '@rover/types';
import { ServiceFrequencyEnum } from '@rover/types/src/ServiceFrequency';

export type AdditionalFilters = {
  serviceType: Partial<ServiceType>;
  serviceTypeOptions: SearchFiltersOptions;
  excludedPersonOpks?: string[];
};

const setDefaultSearchValues = (
  filters: Partial<SearchFilters>,
  { serviceType, serviceTypeOptions, excludedPersonOpks }: AdditionalFilters
): Partial<SearchFilters> => {
  const serviceTypeSlug = serviceType.slug ?? filters.serviceType ?? '';
  const updatedFilters: Partial<SearchFilters> = { ...filters };

  if (!shouldShowFulltimeAvailability(serviceTypeSlug)) {
    updatedFilters.fulltimeAvailability = false;
  }

  if (
    !shouldShowDaytimeServiceScheduler(serviceType?.supportsRepeatBookings, serviceTypeSlug) ||
    filters.frequency !== ServiceFrequencyEnum.REPEAT
  ) {
    updatedFilters.monday = false;
    updatedFilters.tuesday = false;
    updatedFilters.wednesday = false;
    updatedFilters.thursday = false;
    updatedFilters.friday = false;
    updatedFilters.saturday = false;
    updatedFilters.sunday = false;
  }

  if (!shouldShowDaytimeAvailability(serviceTypeSlug, filters, serviceTypeOptions)) {
    updatedFilters.morningAvailability = false;
    updatedFilters.middayAvailability = false;
    updatedFilters.eveningAvailability = false;
  }

  if (excludedPersonOpks) {
    // Exclusions are parsed as excluded person IDs by the best matches system
    updatedFilters.excludedPersonOpks = excludedPersonOpks.join('-');
  }

  return updatedFilters;
};

export default setDefaultSearchValues;
